import { useState } from "react";
import { useLocation } from "react-router-dom";
import useSWR from "swr";

const usePaginatedList = (path, fetcher) => {
  const [isRefreshing, setRefreshing] = useState(false);
  const { data, error, mutate, isValidating } = useSWR(path, {
    revalidateOnFocus: false,
    ...(fetcher && { fetcher }),
  });
  const { search, state, pathname } = useLocation();

  const refreshList = async (silent = false) => {
    if (typeof silent === "boolean") {
      if (!silent) {
        setRefreshing(true);
      }
      await mutate();
      if (!silent) setRefreshing(false);
    } else {
      setRefreshing(true);
      await mutate();
      setRefreshing(false);
    }
  };

  const isFiltering = Boolean(state) && state.prevPathname === pathname && isValidating;

  return {
    data,
    error,
    mutate,
    isValidating,
    isRefreshing,
    refreshList,
    isFiltering,
    page: search.page || 1,
  };
};

export default usePaginatedList;
